/* Moments Theme v5.5.1 — shared Botpoison client */
(() => {
  'use strict';

  const SCRIPT_URL = 'https://unpkg.com/@botpoison/browser';
  let scriptPromise;

  const loadClient = () => {
    if (window.Botpoison) return Promise.resolve(window.Botpoison);
    if (scriptPromise) return scriptPromise;

    scriptPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${SCRIPT_URL}"]`);
      const script = existing || document.createElement('script');
      const timeout = window.setTimeout(() => reject(new Error('Botpoison took too long to load.')), 12000);

      const finish = () => {
        window.clearTimeout(timeout);
        if (window.Botpoison) resolve(window.Botpoison);
        else reject(new Error('Botpoison did not initialize.'));
      };
      const fail = () => {
        window.clearTimeout(timeout);
        reject(new Error('Botpoison could not be loaded.'));
      };

      script.addEventListener('load', finish, { once: true });
      script.addEventListener('error', fail, { once: true });
      if (!existing) {
        script.src = SCRIPT_URL;
        script.async = true;
        script.crossOrigin = 'anonymous';
        document.head.appendChild(script);
      }
    });

    return scriptPromise;
  };

  const validPublicKey = (value) => {
    const key = String(value || '').trim();
    return key && !/replace|add_your|your-public-key/i.test(key);
  };

  window.MomentsBotpoison = {
    isConfigured: validPublicKey,
    async challenge(publicKey) {
      const key = String(publicKey || '').trim();
      if (!validPublicKey(key)) {
        const error = new Error('Botpoison public key is not configured in Theme settings.');
        error.code = 'BOTPOISON_NOT_CONFIGURED';
        throw error;
      }

      const Botpoison = await loadClient();
      const result = await new Botpoison({ publicKey: key }).challenge();
      if (!result?.solution) throw new Error('Botpoison verification did not return a solution.');
      return result.solution;
    }
  };
})();
